import * as oauth from 'oauth4webapi';

import { AuthConfig } from '../SciFinderAuthProvider';

import { getClient, fetchSSOServerMetadata } from './ssoConfig';

const SCOPE = 'sfn-search openid';
const RESPONSE_TYPE = 'code';
const CODE_CHALLENGE_METHOD = 'S256';

export async function buildSSOUrl(state: string, codeVerifier: string, redirectUrl: string, authConfig: AuthConfig) {
  const codeChallenge = await oauth.calculatePKCECodeChallenge(codeVerifier);
  const ssoMetadata = await fetchSSOServerMetadata(authConfig);
  const SSO_BASE_URL = new URL(authConfig.ssoBaseUrl);

  const client = await getClient(authConfig);

  const ssoUrl = new URL(ssoMetadata.authorization_endpoint!, SSO_BASE_URL);
  const ssoParams = {
    client_id: client.client_id,
    redirect_uri: redirectUrl,
    response_type: RESPONSE_TYPE,
    scope: SCOPE,
    code_challenge: codeChallenge,
    code_challenge_method: CODE_CHALLENGE_METHOD,
    state,
  };

  Object.keys(ssoParams).forEach(key => ssoUrl.searchParams.append(key, ssoParams[key] as string));

  return ssoUrl.toString();
}
